import { getStatusMeta } from "@/lib/status";

/**
 * Universal status badge — used on every programme, project and
 * experience card across the Temple of Kulture site.
 *
 * Renders a single small pill: icon + label, colour driven by the
 * status taxonomy (see /app/frontend/src/lib/status.js).
 */
export default function StatusBadge({ status, size = "sm", className = "" }) {
  const meta = getStatusMeta(status);
  const Icon = meta.Icon;
  const sizeClass =
    size === "xs"
      ? "text-[9px] px-2 py-0.5 gap-1"
      : size === "lg"
      ? "text-xs px-3 py-1.5 gap-2"
      : "text-[10px] px-2.5 py-1 gap-1.5";

  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center font-bold uppercase tracking-[0.18em] border ${meta.badgeClass} ${sizeClass} ${className}`}
    >
      {meta.pulse && (
        <span className="relative flex h-1.5 w-1.5 shrink-0">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-current opacity-60" />
          <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-current" />
        </span>
      )}
      <Icon className="h-3 w-3 shrink-0" />
      <span>{meta.label}</span>
    </span>
  );
}
